import React, { useState, Fragment, Component } from 'react'
import PenilaianBloc from "../Blocs/PenilaianBloc"
import { config } from "../../../../../helpers/config_global"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/penilaian360Service'
import apiResponse from '../../../../../services/apiResponse'
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import moment from "moment"
import { Redirect } from "react-router-dom"
import 'moment/locale/id'
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    Tooltip,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label
} from "reactstrap"

class PenialianPegawaiIndexComponent extends Component 
{
    penilaianBloc = new PenilaianBloc();

    source
    historyTable = 'periodePenialian360Active'
    defaultOrder = 'ms360_period_date_end'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
 

    constructor(props) {
        super(props)
        this.state = {
            startUuid: "",
            periodUuid: "",
            inactiveUuid: "",
            dataForm: {},
            obj: null,
            modalShow: false,
            modalToggle: false,
            tooltip: false,  
            detailUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            work_unit_uuid: userdata?.employee_current_work_unit_uuid,
            employee_uuid: userdata?.employee_uuid
        }

        await this.penilaianBloc.fetchPenilaianList(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    componentDidMount() {

        this.setTokenAPI()

        this.penilaianBloc.penilaianListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.penilaianBloc.penilaianBeginChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        detailUuid: this.state.startUuid,
                        startUuid: '',
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    columns = [
        {
            key: "ms360_period_date_start",
            text: "PERIODE AWAL",
            className: "ms360_period_date_start",
            sortable: true,
            cell: record => {
                return (record.ms360_period_date_start != null) ? moment(record.ms360_period_date_start).format('DD MMMM YYYY') : '-';
            }
        },
        {
            key: "ms360_period_date_end",
            text: "PERIODE AKHIR",
            className: "ms360_period_date_end",
            sortable: true,
            cell: record => {
                return (record.ms360_period_date_end != null) ? moment(record.ms360_period_date_end).format('DD MMMM YYYY') : '-';
            }
        },
         {
            key: "ms360_team_work_unit_name",
            text: "UNIT KERJA",
            className: "ms360_team_work_unit_name",
            sortable: true
        },
         {
            key: "ms360_team_alias",
            text: "ALIAS",
            className: "ms360_team_alias",
            sortable: true
        },
        {
            key: "ms360_period_id",
            text: "STATUS",
            className: "ms360_period_id",
            sortable: false,
            align: 'center',
            cell: record => {
                const startDate = record.ms360_period_date_start;
                const endDate = record.ms360_period_date_end;
                const today = moment().startOf('day');
                const start = moment(startDate).startOf('day');
                const end = moment(endDate).endOf('day');
                if (today.isBefore(start)) {
                    return (<span className="badge bg-warning">{'Pending'}</span>)
                }else if (today.isAfter(end)) {
                    return (<span className="badge bg-danger">{'Berakhir'}</span>)
                }else{
                    return (<span className="badge bg-success">{'Berlangsung'}</span>)
                }
            }
        },
        {
            key: "action",
            text: "AKSI",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                // deploy ulang
                const timestamp = Math.floor(Date.now() / 1000);
                const thisId = record?.ms360_team_uuid;
                const status_assesment = record.status_assesment
                const startDate = record.ms360_period_date_start;
                const endDate = record.ms360_period_date_end;
                const today = moment().startOf('day');
                const start = moment(startDate).startOf('day');
                const end = moment(endDate).endOf('day');
                
                if (today.isBefore(start)) {
                    return (<></>)
                }else if (today.isAfter(end)) {
                    return (
                        <>
                            <span>
                                <button 
                                    className="btn btn-success btn-sm" 
                                    id={"detail-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            detailUuid: thisId,
                                            startUuid: null
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-search"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["detail" + thisId] : !this.state["detail" + thisId]
                                        })
                                    }}
                                >Lihat Detail</Tooltip>
                            </span>
                        </>
                    )
                }else{
                    return (
                        <Fragment>
                            { status_assesment === null  ? <>
                                <span>
                                    <button 
                                        className="btn btn-primary btn-sm" 
                                        id={"begin-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                startUuid: thisId,
                                                detailUuid: null,
                                                confirm: true
                                            })
                                        }}
                                        style={{
                                            marginRight: '2px',
                                            padding: '2px 5px'
                                        }}>
                                        <i className="uil uil-edit-alt"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["begin" + thisId]} target={"begin-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["begin" + thisId] : !this.state["begin" + thisId]
                                            })
                                        }}
                                    >Mulai Penialian</Tooltip>
                                </span>
                                </> : <>
                                <span>
                                    <button 
                                        className="btn btn-success btn-sm" 
                                        id={"detail-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                detailUuid: thisId,
                                                startUuid: null
                                            })
                                        }}
                                        style={{
                                            marginRight: '2px',
                                            padding: '2px 5px'
                                        }}>
                                        <i className="uil-search"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["detail" + thisId] : !this.state["detail" + thisId]
                                            })
                                        }}
                                    >Lihat Detail</Tooltip>
                                </span>
                            </> }
                        </Fragment>
                    )
                }

                
            }
        }
    ]

    submitData = async () => {
        const formData = new FormData();
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        formData.append("uuid", this.state.startUuid); // team_uuid
        formData.append("employee_uuid", userdata?.employee_uuid);
        await this.penilaianBloc.fetchBegin(formData)
    };

    componentWillUnmount(){
        this.penilaianBloc.penilaianListChannel.unsubscribe()
        this.penilaianBloc.penilaianBeginChannel.unsubscribe()
    }

    render(){
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            <Card className="">
                                <CardBody>
                                    <CardTitle>Daftar Penialian 360 </CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Kelola Penialian 360
                                    </CardSubtitle>
                                    <hr />
                                    <MKIDatatable
                                        className={this.configDatatable.tableClass}
                                        config={this.configDatatable}
                                        records={this.state.rows}
                                        columns={this.columns}
                                        dynamic={true}
                                        minWidth={1000}
                                        total_record={this.state.totalRow}
                                        initial={this.state.filter}
                                        onChange={(filter) => {
                                            this.setState({
                                                loadingTable: true,
                                                filter: filter
                                            }, function () {
                                                this.setTokenAPI()
                                            });
                                        }}
                                        loading={this.state.loadingTable}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                { this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/penialian360.html?section=detail&uuid=" + this.state.detailUuid}/>
                : null }
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin ?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }

}

export default PenialianPegawaiIndexComponent